<template>
  <div class="detail-main flex flex-column cen-start">
    <template v-if="list && list.length > 0">
      <template v-for="(item, index) in list">
        <ng-card :key="index">
          <div class="detail-content m-bottom-ms">
            <h3>
              <span class="title">{{item.name || '-'}}</span>
              <span
                class="sub-title font-xs"
              >{{`${item.phone_code_item ? item.phone_code_item.prefix : ''} - ${item.phone}` || '-'}}</span>

              <a-tag v-if="item.is_default == '1'" color="black">默认</a-tag>
            </h3>
            <div class="m-bottom-ms font-xs">{{item.address || '-'}} {{item.post_code || '-'}}</div>
          </div>

          <div v-if="editable" class="handle-btns flex" slot="right">
            <a-button v-if="item.is_default != '1'" type="link" @click="onDefault(item)">设为默认地址</a-button>
            <a-button type="link" @click="handleItem($var.Handle.edit, item)">修改</a-button>
            <a-button type="link" class="ant-btn-error" @click="handleItem($var.Handle.del, item)">删除</a-button>
          </div>
        </ng-card>
      </template>
    </template>
    <template v-else>
      <div class="empty flex cen-center">暂无收件信息</div>
    </template>
  </div>
</template>
<script>
  import {NgCard} from '@/components/index';

  export default {
    data() {
      return {
        // list: []
      }
    },

    props: {
      list: Array,
      editable: {
        type: Boolean,
        default: false,
      }
    },

    components: {
      NgCard
    },

    created() {
      // this.getData();
    },
    methods: {

      handleItem(type, item) {
        let vm = this;

        if (type === this.$var.Handle.del) {
          this.$confirm({
            width: '480px',
            title: '确认要删除该地址信息吗？',
            // content: '删除该地址信息',
            onOk() {
              return new Promise(resolve => {
                vm.onDel(item, resolve);
              });
            }
          });
        } else if (type === this.$var.Handle.edit) {
          this.$emit('onEdit', item);
        }
      },

      onDefault(item) {
        let that = this;

        this.$confirm({
          width: '480px',
          title: '确认设置该地址为默认地址信息吗？',
          // content: '删除该地址信息',
          onOk() {
            return new Promise(resolve => {
              that.setDefault(item, resolve);
            });
          }
        });
      },

      setDefault(item, next) {
        let params = {
          express_id: item.express_id
        };

        this.$axios.Address_setDefault(params).then(res => {
          const data = res.data;

          if (data && data.code == 0) {
            this.$message.success('设置成功');

            next();

            this.$emit('success', data.data);
          }
        })
      },

      onDel(item, next) {
        let params = {
          express_id: item.express_id
        };

        this.$axios.Address_del(params).then(res => {
          const data = res.data;

          if (data && data.code == 0) {
            this.$message.success('删除成功');

            next();

            this.$emit('success', data.data);
          }
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .detail-main {
    .title,
    .sub-title {
      margin-right: 20px;
    }
  }
</style>